import { TABLE_COLOR_SCHEME } from '../components/Table/constants';
import { blendHexColors, hex2rgba } from './colors';

/**
 * Set app skin
 * Configuration is taken from BackOffice
 * @param {Object} skin
 */
function setSkin(skin = {}) {
  if (!Object.prototype.hasOwnProperty.call(skin, 'colors')) {
    // eslint-disable-next-line no-console
    console.warn('No skin provided!');
    return;
  }

  const root = document.documentElement;

  for (const key in skin.colors) {
    if (Object.prototype.hasOwnProperty.call(skin.colors, key)) {
      const newKey = `--${key.split('_').join('-')}`;
      root.style.setProperty(newKey, skin.colors[key]);
    }
  }

  if (skin.table) {
    // Set `--table-color` variable to `lobby.table_color_scheme` configuration if available
    root.style.setProperty(
      '--table-color',
      skin.table.table_color_scheme === TABLE_COLOR_SCHEME.BLACK
        ? '#000'
        : '#fff',
    );
  }

  const styles = getComputedStyle(root);

  root.style.setProperty(
    '--roads-background-color',
    blendHexColors(
      [ styles.getPropertyValue('--background-color'), 0.8 ],
      [ '#FFF', 0.1 ],
    ).css,
  );

  root.style.setProperty(
    '--menu-hover-color',
    blendHexColors(
      [ styles.getPropertyValue('--background-color'), 0.8 ],
      [ '#FFF', 0.2 ],
    ).css,
  );

  root.style.setProperty(
    '--main-hover-color',
    blendHexColors(
      [ styles.getPropertyValue('--main-color'), 0.8 ],
      [ '#FFF', 0.2 ],
    ).css,
  );

  // Set --main-color-75 for widgets (roulette)
  root.style.setProperty(
    '--main-text-color-75',
    hex2rgba(styles.getPropertyValue('--main-text-color'), 0.75)
      .css,
  );

  // Set --main-color-6 for widgets (andarbahar, botp)
  root.style.setProperty(
    '--main-text-color-6',
    hex2rgba(styles.getPropertyValue('--main-text-color'), 0.6)
      .css,
  );
}

export default setSkin;
